(() => {
  if (window.gniProductTabsInitialized) return;
  window.gniProductTabsInitialized = true;

  const roots = new Set();

  function activate(root, name, updateUrl = false, moveFocus = false) {
    const tabs = [...root.querySelectorAll('[data-gni-tab]')];
    const panels = [...root.querySelectorAll('[data-gni-panel]')];
    const activeTab = tabs.find((tab) => tab.dataset.gniTab === name);
    const list = root.querySelector('[role="tablist"]');
    if (!activeTab || !list) return;

    tabs.forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.gniPanel !== name;
    });

    list.style.setProperty('--gni-tab-indicator-x', `${activeTab.offsetLeft}px`);
    list.style.setProperty('--gni-tab-indicator-width', `${activeTab.offsetWidth}px`);
    list.classList.add('is-ready');

    if (moveFocus) activeTab.focus({ preventScroll: true });
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.hash = name === 'reviews' ? 'reviews' : '';
      if (url.href !== window.location.href) window.history.pushState(null, '', url);
    }
  }

  function syncFromUrl() {
    const name = window.location.hash === '#reviews' ? 'reviews' : 'details';
    roots.forEach((root) => {
      if (root.isConnected) activate(root, name);
      else roots.delete(root);
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-gni-product-tabs]').forEach((root) => {
      if (root.dataset.gniTabsReady === 'true') return;
      root.dataset.gniTabsReady = 'true';
      roots.add(root);

      const tabs = [...root.querySelectorAll('[data-gni-tab]')];
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(root, tab.dataset.gniTab, true));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(index + step + tabs.length) % tabs.length];
          activate(root, next.dataset.gniTab, true, true);
        });
      });

      activate(root, window.location.hash === '#reviews' ? 'reviews' : 'details');
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => {
          const active = root.querySelector('[data-gni-tab][aria-selected="true"]');
          if (active) activate(root, active.dataset.gniTab);
        }).observe(root.querySelector('[role="tablist"]'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('popstate', syncFromUrl);
  window.addEventListener('hashchange', syncFromUrl);
})();
